export type ReasoningMode = 'FAST' | 'NORMAL' | 'REASONING';

export const AI_REASONING_MODE_STORAGE_KEY = 'boltos_ai_reasoning_mode';
export const DEFAULT_REASONING_MODE: ReasoningMode = 'NORMAL';

const VALID_MODES: ReasoningMode[] = ['FAST', 'NORMAL', 'REASONING'];

export function normalizeReasoningMode(value: unknown): ReasoningMode {
  const mode = typeof value === 'string' ? value.trim().toUpperCase() : '';
  if (VALID_MODES.includes(mode as ReasoningMode)) {
    return mode as ReasoningMode;
  }
  return DEFAULT_REASONING_MODE;
}

export function getAiReasoningMode(): ReasoningMode {
  if (typeof window === 'undefined') {
    return DEFAULT_REASONING_MODE;
  }
  try {
    return normalizeReasoningMode(window.localStorage.getItem(AI_REASONING_MODE_STORAGE_KEY));
  } catch {
    return DEFAULT_REASONING_MODE;
  }
}

export function setAiReasoningMode(mode: ReasoningMode): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(AI_REASONING_MODE_STORAGE_KEY, normalizeReasoningMode(mode));
  } catch {
    // Ignore storage failures (private mode/blocked storage).
  }
}
